var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-layout-wrapper" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("span", {
          staticClass: "header-logo __pointer",
          on: { click: _vm.goVX }
        }),
        _vm._v(" "),
        _c("change-lang", { staticClass: "start change-lang __pointer" })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "confirm-wrapper" }, [
      _c(
        "div",
        { staticClass: "confirm" },
        [
          _c("router-view"),
          _vm._v(" "),
          _vm.$route.name === "start" ? _c("first-notice") : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }